






























































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseMediaTimeSlider from "@/app/shared/components/base/BaseMediaTimeSlider.vue";
import utils from "@/app/shared/utils/utils.js";

export default Vue.extend({
  name: "RendersPreviewWindow",
  components: {
    BaseMediaTimeSlider,
  },
  mixins: [utils],
  data: function () {
    return {
      currentItem: /* {
        outputName: "",
        path: "",
      } */ null,
      mutedStateBeforeOpen: true,
      localMuted: true,
      duration: 0,
      currentTime: 0,
      isPlaying: true,
      wasPlaying: false,
      isOpenControllers: false,
      timer: null,
      dragStart: false,
      videoTimeIntervalListner: null,
    };
  },
  computed: {
    renderItems: {
      // getter
      get: function () {
        return this.$store.state.renderItems.filter((i) => !i.error);
      },
      // setter
      set: function (newValue) {},
    },
    muted: {
      // getter
      get: function () {
        return this.$store.state.muted;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("muted", newValue);
      },
    },
    keymap: function () {
      return {
        esc: this.exit,
        "ctrl+left": this.swipeLeft,
        "command+left": (event) => {
          if (!event.metaKey) {
            return;
          }
          this.swipeLeft();
        },
        "ctrl+right": this.swipeRight,
        "command+right": (event) => {
          if (!event.metaKey) {
            return;
          }
          this.swipeRight();
        },
        space: {
          keyup: (event) => {
            event.stopPropagation();
            if (!this.dragStart) {
              this.playOrPause();
            }
          },
        },
      };
    },
  },

  created() {
    $eventsBus.$on("showRenderItemPreview", (item) => {
      this.onOpen(item);
    });
  },
  methods: {
    downloadFile() {
      const downloadHref = this.$refs.renderedVideo.src;
      const link = document.createElement("a");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link); // Firefox requires the link to be in the body
      link.download = this.currentItem.fileName;
      link.href = downloadHref;
      link.click();
      document.body.removeChild(link);

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("download", {
            "Клик на download": 1,
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    onMouseOver() {
      this.isOpenControllers = true;
    },
    onMouseLeave() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.isOpenControllers = false;
      }, 5000);
    },
    getTimeDisplay() {
      const duration = !this.duration ? 0 : this.duration;

      return (
        this.convertSecondsToTimeboardStyle(this.currentTime) +
        " / " +
        this.convertSecondsToTimeboardStyle(duration)
      );
    },
    startChangeTime() {
      this.dragStart = true;
      if (this.isPlaying) {
        this.wasPlaying = true;
        this.playOrPause();
      }
    },
    changeTime(time) {
      this.setNewTime(time);
    },
    stopChangeTime() {
      this.dragStart = false;
      if (this.wasPlaying) {
        this.wasPlaying = false;
        this.playOrPause();
      }
    },
    playOrPause() {
      this.isPlaying = !this.isPlaying;
      this.isPlaying
        ? this.$refs.renderedVideo.play()
        : this.$refs.renderedVideo.pause();
      if (!this.isOpenControllers) {
        this.onMouseOver();
        this.onMouseLeave();
      }
    },
    setNewTime(videoTime) {
      this.currentTime = videoTime;
      this.$refs.renderedVideo.currentTime = videoTime;
    },
    onOpen(item) {
      this.currentItem = item;
      this.mutedStateBeforeOpen = this.muted;
      this.localMuted = this.muted;
      this.muted = true;

      this.videoTimeIntervalListner = setInterval(() => {
        if (!this.$refs.renderedVideo) {
          this.duration = 0;
          this.currentTime = 0;
        } else {
          this.duration = this.$refs.renderedVideo.duration;
          this.currentTime = this.$refs.renderedVideo.currentTime;
        }
      }, 40);

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.hit(
            this.$baseURL + "/#/watching_video/id_" + this.currentItem.renderId
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    exit() {
      //muted
      this.muted = this.mutedStateBeforeOpen;
      this.currentItem = null;
      this.duration = 0;
      this.currentTime = 0;
      clearInterval(this.videoTimeIntervalListner);
      this.$emit("close");
    },
    swipeLeft() {
      if (this.currentItem !== this.renderItems[0]) {
        let doneTasks = this.renderItems.filter((i) => i.loaded);
        let itemIndex = doneTasks.indexOf(this.currentItem);
        let leftIndex = itemIndex === 0 ? doneTasks.length - 1 : itemIndex - 1;
        this.currentItem = doneTasks[leftIndex];
        //TODO test yandex metrik
        try {
          if (this.$metrika) {
            this.$metrika.hit(
              this.$baseURL +
                "/#/watching_video/id_" +
                this.currentItem.renderId
            );
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    swipeRight() {
      if (this.currentItem !== this.renderItems[this.renderItems.length - 1]) {
        let doneTasks = this.renderItems.filter((i) => i.loaded);
        let itemIndex = doneTasks.indexOf(this.currentItem);
        let rightIndex = itemIndex === doneTasks.length - 1 ? 0 : itemIndex + 1;
        this.currentItem = doneTasks[rightIndex];

        //TODO test yandex metrik
        try {
          if (this.$metrika) {
            this.$metrika.hit(
              this.$baseURL +
                "/#/watching_video/id_" +
                this.currentItem.renderId
            );
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
});
